import React from "react";
import { List, Stack, Typography } from "@mui/material";
import AccordionDetails from "@mui/material/AccordionDetails";
import { useTranslations } from "hooks";
import { getTranslation } from "common";
import {
  GroupModel,
  RolesModel,
  UsersOfSelectedOrganization,
} from "./NewProcessModule";
import UserAssociationItem from "./AssociationComponents/UserAssociationItem";
import GroupAssociationItem from "./AssociationComponents/GroupAssociationItem";
import RoleAssociationItem from "./AssociationComponents/RoleAssociationItem";
import { ExtensionElements } from "model/processModel";

const AssociationList: React.FC<{
  listOfUsersToBeDisplayed: any;
  extensionElements: ExtensionElements | undefined;
  getUsername: (value: UsersOfSelectedOrganization) => string;
  onLaneMouseDown: any;
  selectedLane: string;
  listOfGroupsToBeDisplayed: GroupModel[];
  listOfRolesToBeDisplayed: any;
  oppAccordianRef: any;
}> = ({
  listOfUsersToBeDisplayed,
  extensionElements,
  getUsername,
  onLaneMouseDown,
  selectedLane,
  listOfGroupsToBeDisplayed,
  listOfRolesToBeDisplayed,
  oppAccordianRef,
}) => {
  const translations = useTranslations();
  const laneParticipantIds: string[] =
    (extensionElements &&
      selectedLane &&
      extensionElements[selectedLane]?.map(
        (extEl) => `${extEl.idparticipant}-${extEl.idparticipanttype}`
      )) ||
    [];
    
  const getUsersUi = () => {
    return (
      <Stack flex={1} direction="column" spacing={2}>
        <Typography variant="subtitle1">
          {getTranslation(translations, "users.name")}
        </Typography>
        <List dense disablePadding>
          {listOfUsersToBeDisplayed.map(
            (ele: UsersOfSelectedOrganization, id: any) => (
              <UserAssociationItem
                key={`${ele.id}-3`}
                getUsername={getUsername}
                ele={ele}
                selected={laneParticipantIds.includes(`${ele.id}-3`)}
                onLaneMouseDown={onLaneMouseDown}
                selectedLane={selectedLane}
              />
            )
          )}
        </List>
      </Stack>
    );
  };

  const getGroupsUi = () => {
    return (
      <Stack flex={1} direction="column" spacing={2}>
        <Typography variant="subtitle1">
          {getTranslation(translations, "groups.name")}
        </Typography>
        <List dense disablePadding>
          {listOfGroupsToBeDisplayed.map((ele: GroupModel, ind: any) => (
            <GroupAssociationItem
              key={`association-group-${ele.id}`}
              selected={laneParticipantIds.includes(`${ele.id}-1`)}
              ele={ele}
              ind={ind}
              onLaneMouseDown={onLaneMouseDown}
              selectedLane={selectedLane}
            />
          ))}
        </List>
      </Stack>
    );
  };

  const getRolesUi = () => {
    return (
      <Stack flex={1} direction="column" spacing={2}>
        <Typography variant="subtitle1">
          {getTranslation(translations, "roles.name")}
        </Typography>
        <List dense disablePadding>
          {listOfRolesToBeDisplayed.map((ele: RolesModel, ind: any) => (
            <RoleAssociationItem
              key={`association-role-${ele.id}`}
              selected={laneParticipantIds.includes(`${ele.id}-2`)}
              ele={ele}
              ind={ind}
              onLaneMouseDown={onLaneMouseDown}
              selectedLane={selectedLane}
            />
          ))}
        </List>
      </Stack>
    );
  };
  return (
    <AccordionDetails draggable ref={oppAccordianRef}>
      <Stack width="100%" pt={1} direction="row" spacing={1}>
        {getUsersUi()}
        {getGroupsUi()}
        {getRolesUi()}
      </Stack>
    </AccordionDetails>
  );
};

export default AssociationList;
